/* eslint-disable react/prefer-stateless-function */
import React, { PureComponent } from "react";

class Footer extends PureComponent {
  render() {
    return <div className="footer">THIS IS A FOOTER!</div>;
  }
}

export default Footer;
